/**
 * Контент справки для страницы геозон.
 * Используется в панели справки HelpPanel.
 */
export default {
  // Идентификатор страницы
  pageKey: 'geozones',

  // Ключ локализации заголовка страницы
  titleKey: 'help.pages.geozones.title',

  // Ключ локализации описания страницы
  overviewKey: 'help.pages.geozones.overview',

  // Идентификатор связанного тура
  tourId: 'geozones-page',

  // FAQ - часто задаваемые вопросы
  faq: [
    {
      id: 'create-geozone',
      questionKey: 'help.pages.geozones.faq.createGeozone.question',
      answerKey: 'help.pages.geozones.faq.createGeozone.answer',
    },
    {
      id: 'geozone-types',
      questionKey: 'help.pages.geozones.faq.geozoneTypes.question',
      answerKey: 'help.pages.geozones.faq.geozoneTypes.answer',
    },
    {
      id: 'edit-geozone',
      questionKey: 'help.pages.geozones.faq.editGeozone.question',
      answerKey: 'help.pages.geozones.faq.editGeozone.answer',
    },
    {
      id: 'import-export',
      questionKey: 'help.pages.geozones.faq.importExport.question',
      answerKey: 'help.pages.geozones.faq.importExport.answer',
    },
    {
      id: 'circle-vs-polygon',
      questionKey: 'help.pages.geozones.faq.circleVsPolygon.question',
      answerKey: 'help.pages.geozones.faq.circleVsPolygon.answer',
    },
    {
      id: 'mobile-geozone',
      questionKey: 'help.pages.geozones.faq.mobileGeozone.question',
      answerKey: 'help.pages.geozones.faq.mobileGeozone.answer',
    },
    {
      id: 'speed-limit',
      questionKey: 'help.pages.geozones.faq.speedLimit.question',
      answerKey: 'help.pages.geozones.faq.speedLimit.answer',
    },
    {
      id: 'geozone-notifications',
      questionKey: 'help.pages.geozones.faq.geozoneNotifications.question',
      answerKey: 'help.pages.geozones.faq.geozoneNotifications.answer',
    },
  ],

  // Контекстные подсказки для элементов страницы
  tooltips: {
    mapToolbar: 'help.tooltips.geozones.mapToolbar',
    drawingTools: 'help.tooltips.geozones.drawingTools',
    search: 'help.tooltips.geozones.search',
    filter: 'help.tooltips.geozones.filter',
    geozoneCard: 'help.tooltips.geozones.geozoneCard',
  },

  // Связанные туры
  relatedTours: ['onboarding', 'devices-page', 'dashboard-page'],
}
